var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeisure03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.726562,
    y: 0.53125,
    width: 350,
    height: 233,
    fill: "#E09064"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.463 71.3828C261.463 70.8305 261.911 70.3828 262.463 70.3828H265.189C265.741 70.3828 266.189 70.8305 266.189 71.3828V146.704H261.463V71.3828Z",
    fill: "#4841A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.824 72.4297L300.768 118.609C301.193 119.14 300.975 119.932 300.338 120.17L263.824 133.863V72.4297Z",
    fill: "#353071"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M263.824 74.793L293.873 118.71C294.222 119.221 294.028 119.923 293.466 120.183L263.824 133.864V74.793Z",
    fill: "#8F87F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.463 81.8828L240.7 127.849C240.44 128.424 240.771 129.093 241.386 129.235L261.463 133.865V81.8828Z",
    fill: "#F0EFF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M261.463 81.8828L261.351 84.2966L259.093 132.824L261.463 133.865V81.8828Z",
    fill: "#ABA9C8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.025 151.541C217.439 150.94 217.81 149.928 218.646 149.848L309.108 141.143C309.925 141.064 310.484 141.949 310.062 142.653L297.196 164.096C297.015 164.397 296.69 164.581 296.338 164.581H231.167C230.897 164.581 230.639 164.473 230.451 164.28L218.025 151.541Z",
    fill: "#4841A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M309.108 141.143L244.922 147.324C274.136 155.464 285.042 156.038 301.588 156.773L310.061 142.653C310.484 141.949 309.925 141.064 309.108 141.143Z",
    fill: "#353071"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeisure03);
export default __webpack_public_path__ + "static/media/leisure_03.76f923f600b5c7a5c27336dd2205649d.svg";
export { ForwardRef as ReactComponent };